module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_squareHover-389652a1d91e17e5ddbe94a8d8ea037d.jpg";